import { render, staticRenderFns } from "./PendingExplanations.vue?vue&type=template&id=033bde9c&scoped=true"
import script from "./PendingExplanations.vue?vue&type=script&lang=js"
export * from "./PendingExplanations.vue?vue&type=script&lang=js"
import style0 from "./PendingExplanations.vue?vue&type=style&index=0&id=033bde9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033bde9c",
  null
  
)

export default component.exports